export enum Actions {
    FETCH_BREWERIES = 'fetchBreweries',
    FETCH_EVENTS = 'fetchEvents',
}

export enum Mutations {
    SET_BREWERIES = 'setBreweries',
    SET_EVENTS = 'setEvents',
    SET_AUTHENTICATED = 'setAuthenticated',
    SET_LOGGEDIN_USER = 'setLoggedInUser',
}
